import type {SettingValueType} from "#material/sockets/setting-value-type"

export const colorForValueType = (valueType?: SettingValueType): string | undefined => {
    if (!valueType) {
        return undefined
    }
    switch (valueType) {
        case "vector":
            return "#6e5eb2"
        case "color":
            return "#8d802f"
        case "float":
        case "string":
        // fallthrough
        case "boolean":
            // case "scalar":
            return "#4987af"
        case "closure":
            // case "shader":
            return "#2d8a5d"
    }
    return "#b5b5b5"
}
